<template>
  <div>
    <app-timeline>
      <app-timeline-item
          v-for="binnacle in binnacles"
          :key="binnacle.bitacoraId"
          icon="InfoIcon"
          :variant="getSeveridadBitacoraVariant(binnacle.severidad)"
      >
        <div
            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>{{ binnacle.usuarioNombre }}</h6>
          <small class="text-muted">{{ binnacle.fecha | dateCompleteFormat }}</small>
        </div>
        <div
            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <p>{{ binnacle.mensaje }}</p>
          <!-- 1st Col -->
          <div class="mb-1 mb-sm-0">
            <div>
              <b-avatar
                  v-if="binnacle.tipoVista == -1 || binnacle.tipoVista == 0"
                  v-b-tooltip.hover
                  title="Registro Visible solo para Admin"
                  text="O"
                  class="mr-50"
                  size="24"
                  icon="eye-slash-fill"
                  variant="secondary"
              />
              <b-avatar
                  v-has-permission="'FEB99'"
                  v-b-tooltip.hover
                  title="Copiar Seguimiento"
                  text="S"
                  class="mr-50 add-code"
                  size="24"
                  icon="bug"
                  variant="success"
                  @click.native="copyToClipboard(binnacle.seguimientoId)"
              />
            </div>
          </div>
        </div>
      </app-timeline-item>
    </app-timeline>
  </div>
</template>
<script>

import { BAvatar } from 'bootstrap-vue';

import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  name: 'BinnacleList',
  mixins: [CopyToClipboard],
  props: {
    binnacles: {
      type: [Array],
      required: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  components: {
    AppTimeline, AppTimelineItem, BAvatar
  },
  methods: {
    getSeveridadBitacoraVariant(severidad) {
      switch (severidad) {
        case 1:
          return 'info';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        default:
          return 'secondary';
      }
    }
  }
};

</script>
<style>
.wrap-binnacle {
  height: 400px;
  overflow-y: scroll;
}

.add-code {
  cursor: copy;
}

.crazy-zindex {
  z-index: 10001;
}
</style>
